<router-outlet/>
<div class="version">
  v{{ version }}
</div>
